
import { NavLink } from "react-router-dom";
import "../style/testing_method.css";


export default function TestingMethod  () {
  return (
    <>
      {/* HERO SECTION */}
      <section className="testing-methods-hero-guide-banner">
    
          <div className="hero-icon-container">
            <i className="fas fa-code"></i>
          </div>

          <h1>Testing Methodologies</h1>
          <p>
            Explore the structured and dynamic approaches used to execute
            software testing across the development lifecycle.
          </p>
    
      </section>

      {/* NAV TABS */}
      <nav className="nav-tabs">
        <NavLink to="/software-testing">
          <i className="fa-solid fa-book-open"></i> Overview
        </NavLink>

        <NavLink to="/testing-types">
          <i className="fa-solid fa-box"></i> Types
        </NavLink>

        <NavLink to="/testing-pyramid">
          <i className="fa-solid fa-puzzle-piece"></i> Pyramid
        </NavLink>

        <NavLink to="/testing-methods" className="active">
          <i className="fa-solid fa-code"></i> Methods
        </NavLink>

        <NavLink to="/testing-practices">
          <i className="fa-solid fa-lightbulb"></i> Practices
        </NavLink>

        <NavLink to="/testing-tools">
          <i className="fa-solid fa-screwdriver-wrench"></i> Tools
        </NavLink>
      </nav>

      {/* MAIN CONTENT */}
      <main className="testing-method-guide-content-container">
        <div className="methodology-grid">

          {/* BLACK BOX */}
          <div className="method-card black-box">
            <div className="tag black-box-tag">Functional</div>
            <h3>
              Black Box Testing{" "}
              <NavLink to="/black-box-testing">
                <i className="fas fa-external-link-alt"></i>
              </NavLink>
            </h3>
            <p className="description">
              Testing without knowledge of internal code structure. Focus on
              inputs and outputs.
            </p>
            <h4>Techniques:</h4>
            <ul>
              <li>Equivalence partitioning</li>
              <li>Boundary value analysis</li>
              <li>Decision table testing</li>
              <li>State transition testing</li>
              <li>Use case testing</li>
            </ul>
          </div>

          {/* WHITE BOX */}
          <div className="method-card white-box">
            <div className="tag white-box-tag">Structural</div>
            <h3>White Box Testing
              <NavLink to="/white-box-testing"><i className="fas fa-external-link-alt"></i></NavLink>
            </h3>
            <p className="description">
              Testing with full knowledge of internal structure and code. Focus
              on logic and flow.
            </p>
            <h4>Techniques:</h4>
            <ul>
              <li>Statement coverage</li>
              <li>Branch coverage</li>
              <li>Path coverage</li>
              <li>Condition coverage</li>
              <li>Loop testing</li>
            </ul>
          </div>

          {/* GREY BOX */}
          <div className="method-card grey-box">
            <div className="tag grey-box-tag">Hybrid</div>
            <h3>Grey Box Testing
               <NavLink to="/what-is-gray-box-testing"><i className="fas fa-external-link-alt"></i></NavLink>
            </h3>
            <p className="description">
              Combination of black box and white box testing. Partial knowledge
              of internals.
            </p>
            <h4>Use Cases:</h4>
            <ul>
              <li>Integration testing</li>
              <li>Penetration testing</li>
              <li>Database testing</li>
              <li>Architecture verification</li>
            </ul>
          </div>

          {/* EXPLORATORY */}
          <div className="method-card exploratory">
            <div className="tag exploratory-tag">Dynamic</div>
            <h3>Exploratory Testing
              <NavLink to="/what-is-exploratory-testing"><i className="fas fa-external-link-alt"></i></NavLink>
            </h3>
            <p className="description">
              Simultaneous learning, test design, and execution. Tester actively
              explores the application.
            </p>
            <h4>Benefits:</h4>
            <ul>
              <li>Discovers unexpected issues</li>
              <li>Adapts to changes quickly</li>
              <li>Leverages tester creativity</li>
              <li>Supplements scripted tests</li>
            </ul>
          </div>
        </div>

        {/* TDD SECTION */}
        <section className="content-box tdd-section">
          <h3 className="section-sub-heading">
            Test Driven Development (TDD)
          </h3>
          <p>
            A development methodology where tests are written before the actual
            code.
          </p>

          <div className="tdd-cycle">
            <h4>The TDD Cycle (Red-Green-Refactor):</h4>
            <ol>
              <li>
                <span className="tdd-step-red">Red:</span> Write a failing test
                for the desired functionality.
              </li>
              <li>
                <span className="tdd-step-green">Green:</span> Write minimal code
                to make the test pass.
              </li>
              <li>
                <span className="tdd-step-refactor">Refactor:</span> Improve code
                while keeping tests passing.
              </li>
              <li>Repeat the cycle for next functionality.</li>
            </ol>
          </div>
        </section>

        {/* BDD SECTION */}
        <section className="content-box bdd-section">
          <h3 className="section-sub-heading">
            Behavior Driven Development (BDD)
          </h3>
          <p>
            Extension of TDD that emphasizes collaboration between developers,
            QA, and non-technical stakeholders.
          </p>

          <div className="bdd-format-box">
            <h4>Given-When-Then Format:</h4>
            <ul>
              <li><strong>Given:</strong> Initial context or preconditions.</li>
              <li><strong>When:</strong> Event or action that occurs.</li>
              <li><strong>Then:</strong> Expected outcome or result.</li>
            </ul>

            <div className="bdd-scenario">
              <p className="scenario-title">
                Scenario: User login with valid credentials
              </p>
              <p className="bdd-given">
                Given the user is on the login page
              </p>
              <p className="bdd-when">
                When they enter valid credentials
              </p>
              <p className="bdd-then">
                Then they should be redirected to dashboard
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};


